import { cn } from '@/lib/cn';

function Banner({
  className,
  children,
  overlay = true,
  ...props
}: React.ComponentProps<'div'> & { overlay?: boolean }) {
  return (
    <div
      className={cn(
        'relative h-40 w-full overflow-hidden rounded-2xl md:h-60',
        className
      )}
      {...props}
    >
      {overlay && <BannerOverlay />}
      {children}
    </div>
  );
}

function BannerOverlay({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'absolute inset-0 h-full bg-gradient-to-t from-black/60 to-transparent',
        className
      )}
      {...props}
    ></div>
  );
}

interface BannerImageProps {
  alt?: string;
}

function BannerImage({
  className,
  alt,
  ...props
}: React.ComponentProps<'img'> & BannerImageProps) {
  return (
    <img
      className={cn('h-full w-full object-cover', className)}
      {...props}
      alt={alt}
    ></img>
  );
}

function BannerContent({
  className,
  children,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn(
        'absolute inset-0 flex h-full flex-col justify-end p-3 md:gap-1 md:p-4',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}

function BannerTitle({
  className,
  children,
  ...props
}: React.ComponentProps<'h3'>) {
  return (
    <h3
      className={cn(
        'text-xl font-semibold text-neutral-100 md:text-4xl',
        className
      )}
      {...props}
    >
      {children}
    </h3>
  );
}

function BannerDescription({
  className,
  ...props
}: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('text-sm text-neutral-100 md:text-base', className)}
      {...props}
    ></div>
  );
}

export { Banner, BannerImage, BannerContent, BannerTitle, BannerDescription };
